import React, { useEffect } from "react"

import FaqTemplate from "../templates/FaqTemplate"
import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

const data = [
    {
        title: "Which doctors or hospitals can I visit?",
        body:
            "\n\t\tSince a student health plan is not an HMO or PPO plan, you can visit the doctor or hospital of your choice. No referrals are needed, no out-of-network penalties are incurred ... you pick who you want!\n\t\t",
    },
    {
        title: "Do health care services need to be preauthorized?",
        body:
            "\n\t\tNo. Our current offerings are indemnity plans, meaning you can visit any doctor or hospital that you choose. Payment of services are based on usual, customary, and reasonable charges for the area where services have been rendered and according to the benefits outlined in the plan chosen.\n\t\t",
    },
    {
        title: "Who can purchase student health insurance?",
        body:
            "\n\t\tYou must be an eligible college student at least 17 years of age.\n\nAn eligible student can be full time (9 units), part time (6 units), or even non-traditional.\n\t\t",
    },
    {
        title: "Are foreign exchange students eligible for coverage?",
        body:
            "\n\t\tIf students are enrolled in school based in the United States and are studying overseas for a semester, then they are covered. Students who are not United States citizens and are taking classes in the United States are not eligible for coverage.\n\t\t",
    },
    {
        title:
            "Can I add my family members (spouse and dependents) to my policy?",
        body:
            "\n\t\tThere are individual policies and individuals with dependent policies. If there is a need to cover a spouse and/or child(ren), then you would need to enroll in a plan that includes dependent coverage. A spouse does not have to be enrolled in college to be covered. Student plans do, however, comply with any state requirements for the coverage of newborns.\n\t\t",
    },
    {
        title:
            "As a parent, should I purchase a student insurance plan for my child, or cover them through my standard medical plan?",
        body:
            "\n\t\tAn informed answer depends on several factors. You may want to consider a separate student plan for your child if one or more of the following apply to you:\n<ul>\n\t<li>\n<div>The HMO or PPO network for your insurance plan does not have physician or hospital coverage in the area around your child's college.</div></li>\n\t<li>\n<div>Your child is nearing the age when he or she can no longer be covered under your plan. Often, this is around age 26, but you should check with your insurance company to find out the specific age limit for your current policy.</div></li>\n\t<li>\n<div>The cost savings of removing your child from your insurance plan is greater than the cost of the separate student insurance plan. To determine if this is the case, get a quote on this website for a student plan for your child, and then compare that to the cost savings of removing your child from your standard medical plan (you may need to contact your insurance company to determine this amount).</div></li>\n</ul>\nOn the other hand, a separate student plan may not be appropriate if you are currently satisfied with the coverage, cost, and benefits of your current medical plan.\n\t\t",
    },
    {
        title: "Am I covered year-round or just while school is in session?",
        body:
            "\n\t\tWith a student insurance plan, you're covered year-round, not just during the school term. And, if for some reason, you have to leave school, your coverage stays with you for the remainder of the policy year, and then it's guaranteed renewable.\n\t\t",
    },
    {
        title: "Will I be covered when I go out of state?",
        body:
            "\n\t\tA student insurance plan travels with you anywhere in the United States, its possessions, and Canada. And, although it does not cover you in a foreign country, a student plan does cover you for an emergency medical evacuation to the home country or a facility operating within its laws.\n\t\t",
    },
    {
        title: "What happens if I transfer schools?",
        body:
            "\n\t\tIf you need to transfer schools, your student insurance moves with you. Student coverage is not tied to any one school. There's no need to change coverage or reapply. In fact, you're covered when traveling anywhere in the United States, its possessions, or Canada.\n\t\t",
    },
    {
        title: "Will my coverage be in jeopardy if I drop a class?",
        body:
            '\n\t\tNo, not as long as:\n<ul class="tdisc" style="margin-top: 0px;">\n<ul class="tdisc" style="margin-top: 0px;">\n\t<li>\n<div class="toppad">You met the definition of an eligible student on the date the application was signed.</div></li>\n\t<li>\n<div class="toppad">The premium is paid in full.</div></li>\n</ul>\n</ul>\n&nbsp;\n\t\t',
    },
    {
        title: "If I graduate or drop out of school will I lose my coverage?",
        body:
            "\n\t\tNo, provided that you attended school full-time for 31 days after the policy effective date, then you will be covered for 365 days from your enrollment date, as long as premiums are paid.\n\t\t",
    },
    {
        title: "How far in advance of the beginning of school can I apply?",
        body:
            "\n\t\tYou can apply within 30 days of the start of your classes. The policy will be sent out as soon as it is issued.\n\t\t",
    },
    {
        title: "When does my coverage begin?",
        body:
            "\n\t\tCoverage can begin as soon as the day after you apply or up to no more than 30 days after you apply. Coverage effective dates are determined by each insurance company and are subject to their specific guidelines and procedures.\n\t\t",
    },
    {
        title: "How many times can the insurance plan be renewed?",
        body:
            "\n\t\tStudent health insurance is renewable as long as you need it. Whereas most college plans only cover you until you graduate or very shortly thereafter, the student plans offered on our site can be renewed as long as you need it and as long as your premiums are paid.\n\t\t",
    },
]

export default () => {
    useEffect(() => {
        window._waEvents.push("pageView", {
            page: {
                section: "student-health-insurance-faq",
                name: "page:student-health-insurance-faq",
                language: "english",
            },
            sysEnv: {
                siteGroup: "rc",
            },
        })
    })

    return (
        <>
            <SEO
                title="Student Health Insurance FAQs - eHealth Insurance"
                excerpt="All the resources students need to navigate the world of health insurance while they’re pursuing an education."
                slug="student-health-insurance-faq/"
                pageType="resources"
            />
            <FaqTemplate
                data={data}
                categoryName="Student Health Insurance"
                categorySlug="vision-insurance"
            />
        </>
    )
}
